import { Component, Vue } from 'vue-property-decorator';
import store from '@/store';

@Component
export default class LatestMenu extends Vue {

  get specialoffer() {
    return store.getters["latestMenu/specialoffer"];
  }

  get campaign() {
    return store.getters["latestMenu/campaign"];
  }

  get news() {
    return store.getters["latestMenu/news"];
  }

  get pickup() {
    return store.getters["latestMenu/pickup"];
  }
}
